// For code that alters elements outside of knockout.
var registrationArea = {
    viewModel: {},

    businessOrIndividualNavBar: {
        text: Alkami.Localization.SiteText['Registration.Mobile.NavBar.Register'],
        left: { button: 'back', callback: 'registrationArea.viewModel.cancelRegistration()' }
    },

    disclosureNavBar: {
        text: Alkami.Localization.SiteText['Registration.Mobile.NavBar.Register'],
        left: { button: 'back', callback: 'registrationArea.viewModel.cancelRegistration()' }
    },

    disclosureWithAgreeButtonNavBar: {
        text: Alkami.Localization.SiteText['Registration.Mobile.NavBar.Register'],
        left: { button: 'back', callback: 'registrationArea.viewModel.cancelRegistration()' },
        right: { button: 'custom', text: Alkami.Localization.SiteText['Registration.Mobile.Header.Agree'], callback: 'registrationArea.viewModel.next()' }
    },

    confirmIdentityNavBar: {
        text: Alkami.Localization.SiteText['Registration.Mobile.NavBar.ConfirmIdentity'],
        left: { button: 'back', callback: 'registrationArea.viewModel.cancelRegistration()' }
    },

    confirmIdentityEditFieldWithEnabledDoneNavBar: {
        text: Alkami.Localization.SiteText['Registration.Mobile.NavBar.EnterInformation'],
        left: { button: 'custom', text: Alkami.Localization.SiteText['Registration.Mobile.Header.Cancel'], callback: 'registrationArea.showConfirmIdentityPanel()' },
        right: { button: 'custom', text: Alkami.Localization.SiteText['Registration.Mobile.Header.Done'], callback: 'registrationArea.viewModel.done()' }
    },

    confirmIdentityEditFieldWithDisabledDoneNavBar: {
        text: Alkami.Localization.SiteText['Registration.Mobile.NavBar.EnterInformation'],
        left: { button: 'custom', text: Alkami.Localization.SiteText['Registration.Mobile.Header.Cancel'], callback: 'registrationArea.showConfirmIdentityPanel()' },
        right: { button: 'custom', text: Alkami.Localization.SiteText['Registration.Mobile.Header.Done'], disabled: 'true', callback: '' }
    },

    confirmIdentityEditFieldWithListNavBar: {
        text: Alkami.Localization.SiteText['Registration.Mobile.NavBar.EnterInformation'],
        left: { button: 'custom', text: Alkami.Localization.SiteText['Registration.Mobile.Header.Cancel'], callback: 'registrationArea.showConfirmIdentityPanel()' }
    },

    usernameNavBar: {
        text: Alkami.Localization.SiteText['Registration.Mobile.NavBar.ChooseUsername'],
        left: { button: 'back', callback: 'registrationArea.viewModel.cancelRegistration()' }
    },

    updateTitleBar: function (nativeNavBar) {
        window.nativeHook.updateNavBar(nativeNavBar);

        $('#nav_back,#nav_cancel,#nav_agree,#nav_done').addClass('hidden').removeClass('disabled');
        $('#page_title').text(nativeNavBar.text);

        if (nativeNavBar.left) {
            if (nativeNavBar.left.button === 'back')
                $('#nav_back').removeClass('hidden');
            else if (nativeNavBar.left.button === 'custom' && nativeNavBar.left.text === Alkami.Localization.SiteText['Registration.Mobile.Header.Cancel'])
                $('#nav_cancel').removeClass('hidden');
        }

        if (nativeNavBar.right && nativeNavBar.right.button === 'custom') {
            if (nativeNavBar.right.text === Alkami.Localization.SiteText['Registration.Mobile.Header.Agree']) {
                $('#nav_agree').removeClass('hidden');
            } else if (nativeNavBar.right.text === Alkami.Localization.SiteText['Registration.Mobile.Header.Done']) {
                if (nativeNavBar.right.disabled) {
                    $('#nav_done').addClass('disabled');
                }
                $('#nav_done').removeClass('hidden');
            }
        }
    },

    showBusinessOrIndividualPanel: function () {
        $('#business_or_individual_panel').removeClass("hidden");
        registrationArea.updateTitleBar(registrationArea.businessOrIndividualNavBar);
    },

    showDisclosurePanel: function () {
        $('#disclosure_panel').removeClass("hidden");
        registrationArea.updateTitleBar(registrationArea.disclosureNavBar);
    },

    showDisclosureAgreeButton: function () {
        registrationArea.updateTitleBar(registrationArea.disclosureWithAgreeButtonNavBar);
    },

    showConfirmIdentityPanel: function () {
        window.setTimeout(function () {
            $('#confirm_identity_panel').show().focus();
            $('#confirm_identity_edit_field_panel').hide();
        }, 100);
        registrationArea.updateTitleBar(registrationArea.confirmIdentityNavBar);
    },

    showConfirmIdentityEditFieldPanel: function (titleIfList) {
        $('#confirm_identity_edit_field_panel').show()
        $('#confirm_identity_panel').hide();

        if (titleIfList) {
            var navBar = registrationArea.confirmIdentityEditFieldWithListNavBar;
            navBar.text = titleIfList;
            registrationArea.updateTitleBar(navBar);
        } else {
            registrationArea.updateTitleBar(registrationArea.confirmIdentityEditFieldWithDisabledDoneNavBar);
        }
    },

    showUsernamePanel: function (usernameLabel) {
        $('#mm_side_panels').data('mmenu').openPanel($('#username_panel'));
        registrationArea.usernameNavBar.text = Alkami.Localization.SiteText['Registration.Mobile.NavBar.Choose'] + usernameLabel;
        registrationArea.updateTitleBar(registrationArea.usernameNavBar);
    }
};

$(function() {

    $('#mm_side_panels').mmenu({
        'offCanvas': {
            'position': 'right',
            'zposition': 'front'
        }
    });

    registrationArea.viewModel = new RegistrationWizard(modelData);

    ko.applyBindings(registrationArea.viewModel);

    $.validator.addMethod("validusername", function (value, element) {
        var regex = new RegExp(modelData.UsernameRegEx, 'g');
        return this.optional(element) || regex.test(value);
    }, modelData.UsernameLabelText + Alkami.Localization.SiteText['Username.IsInvalid']);

    $('#username_form').validate({
        rules: {
            'LoginId': {
                required: true,
                minlength: modelData.UsernameMinLength,
                maxlength: modelData.UsernameMaxLength,
                validusername: true
            }
        },
        messages: {
            'LoginId': { required: modelData.UsernameLabelText + Alkami.Localization.SiteText['Username.IsRequired'] }
        },
        errorPlacement: function (error) {
            error.appendTo($('#username_form_errors .error-text'));
        },
        highlight: function () {
            setTimeout(function () {
                var $form = $('#username_form');
                $form.find('.ani-input-error-block').height($form.find('.error-text').outerHeight(true)).addClass('show');
                $form.find('.input-container').addClass('ani-input-error');
            }, 100);
        },
        unhighlight: function () {
            var $form = $('#username_form');
            $form.find('.ani-input-error-block').height(0).addClass('show');
            $form.find('.input-container').removeClass('ani-input-error');
        }
    });
});
